import { ITypeTicketCollectionData } from 'meta/pages/v4/typeticketcollection'
import { ApiEndpoint } from 'controller/endpoint'
import { HttpRequestForApiV4 } from 'utils/http'

type Props = {
  ids: number[]
}

type Response = { items: ITypeTicketCollectionData[] }

export const getBulkData = async (props: Props): Promise<Response> => {
  const { ids } = props

  const endpoint = ApiEndpoint.v4.typeticketcollection.bulk(ids.map((x) => String(x)))

  const { data } = await HttpRequestForApiV4.get<Response>(endpoint)
  return data
}
